module.exports = __webpack_public_path__ + "img/three-logo.73616c34.png";